import {useEffect} from 'react';

import get from 'lodash-es/get';

import {JwtScope} from '@common/types/authentication/authentication.types';
import useInterval from '@common/hooks/useInterval';
import {SCOPED_JWT_REFRESH_DELAY} from '@common/constants/authentication/authenticationConstants';
import {getScopedJwt, checkJwt} from '@common/helpers/authentication/authenticationHelper';
import useAuthenticationStore from '@common/stores/authenticationStore';

export const useScopedJwt = (jwtScope: JwtScope) => {
  const {user, roles, scopedJwts, mainJwt, refreshScopedJwt, setScopedJwt, buildScopedJwt} = useAuthenticationStore();
  const scopedJwt = get(scopedJwts, jwtScope?.scope);

  const externalScopedJwt = getScopedJwt(jwtScope.scope);

  useInterval(() => {
    if (mainJwt && scopedJwt) {
      refreshScopedJwt(jwtScope.scope);
    }
  }, SCOPED_JWT_REFRESH_DELAY);

  useEffect(() => {
    if (!scopedJwt && jwtScope.scope) {
      if (externalScopedJwt && checkJwt(externalScopedJwt)) {
        setScopedJwt(externalScopedJwt, jwtScope.scope);
      } else {
        buildScopedJwt(jwtScope.scope, get(jwtScope, 'assets', []), get(jwtScope, 'withStatic', false));
      }
    }
  }, [externalScopedJwt, jwtScope]);

  return scopedJwt ? {scopedJwt, user, roles} : {};
};
